import {
  type EnvironmentProviders,
  makeEnvironmentProviders,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  type Routes,
  TitleStrategy,
  withComponentInputBinding,
} from '@angular/router';

import { provideAmpHttp } from '@amp/shared/http';
import { provideAmpI18n } from '@amp/shared/i18n';
import { providePboCustomIcons } from '@bo-ui/pinata/icon';
import { providePboTheme } from '@bo-ui/pinata/themes';
import { ampDefaultRoutes } from './amp-default-routes';
import { AmpTitleStrategy } from './amp-title.strategy';
import type { AmpAppId } from './app-shell.model';
import { AMP_APP_SHELL_CONFIG } from './provide-app-shell';
import { shellConfig } from './shell-config';

export function provideAmpApplication(options: {
  appId: AmpAppId;
  routes?: Routes;
}): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    ...(options.appId === 'platform' ? [] : [provideAmpHttp()]),
    provideRouter(options.routes ?? ampDefaultRoutes, withComponentInputBinding()),
    provideAmpI18n(),
    { provide: AMP_APP_SHELL_CONFIG, useValue: shellConfig(options.appId) },
    { provide: TitleStrategy, useClass: AmpTitleStrategy },
    providePboTheme(),
    providePboCustomIcons(),
  ]);
}
